<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <router-link
        class="profile-link"
        active-class
        :exact="true"
        :to="{ name: 'AddWork' }"
      >
        <v-btn color="#6A158E" dark v-if="permitObj.work_add">+ Add Work</v-btn>
      </router-link>

      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <work-table></work-table>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import WorkTable from "../../../components/work/WorkTable.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
  name: "Work",
  components: { WorkTable, BreadCrumbs },
  data() {
    return {
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
      permitObj: {},
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "Works";
      this.permitObj = getPermitObjects(links, pathName);
    }
  },
  mounted() {
    this.getPermittedArray();
  },
};
</script>

<style scoped>
</style>